<template>
  <article class="project-content" ref="content">
    <slot></slot>
  </article>
</template>

<script>
import ScrollMagic from 'scrollmagic'
import 'ScrollMagicIndicator'

export default {
  name: 'project-body',
  data () {
    return {
      controller: '',
      menuBtnScene: '',
      revealScene: ''
    }
  },
  mounted () {
    this.$store.commit('inHeader')
    this.controller = new ScrollMagic.Controller()
    this.menuBtnScene = new ScrollMagic.Scene({
      triggerElement: this.$refs.content
    })
    .on('enter leave', (e) => {
      if (e.type === 'enter') {
        this.$store.commit('outHeader')
      } else {
        this.$store.commit('inHeader')
      }
    })
    .addTo(this.controller)

    this.$refs.content.childNodes.forEach(item => {
      if (item.nodeType === Node.ELEMENT_NODE) {
        item.classList.add('mounted')

        this.revealScene = new ScrollMagic.Scene({
          triggerElement: item,
          triggerHook: 'onEnter',
          offset: 200
        })
        // .addIndicators()
        .on('enter leave', (e) => {
          if (e.type === 'enter') {
            item.classList.add('reveal')
          } else {
            item.classList.remove('reveal')
          }
        })
        .addTo(this.controller)
      }
    })// forEach

    this.$refs.content.classList.add('loaded')
  }, // mounted
  beforeDestroy () {
    this.$store.commit('outHeader')
    this.controller.destroy()
    this.controller = ''
    this.menuBtnScene = ''
    this.revealScene = ''
  }
}
</script>

<style lang="scss" scoped>
  article {
    overflow: hidden;
    opacity: 0;
    transition: opacity 0.2s linear;
    transition-delay: 0.2s;

    &.loaded {
      opacity: 1;
    }

    @include device(laptop) {
      padding: 0 60px;
    }

    @include device(mobile) {
      padding: 0 20px;
    }
  }

  .mounted {
    margin: 150px auto;
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.5s ease-out;
    transition-property: opacity, transform;

    @include device(mobile) {
      margin: 100px auto;
    }

    &.reveal {
      opacity: 1;
      transform: translateY(0);
    }
  }

  p {
    font-size: 16px;
    line-height: 24px;
    max-width: 500px;
    color: $color-black;
  }

  img, video {
    display: block;
    width: 100%;
    max-width: $size-max-width;
  }

  video {
    border-radius: 6px;

    @include device(mobile) {
      border-radius: 2px;
    }
  }

  i {
    display: block;
    width: 100%;
    max-width: $size-max-width;
    text-align: center;
    color: #aaa;
  }

  em.desc {
    font-style: normal;
    display: block;
    text-align: center;
    max-width: $size-max-width;
    margin-top: -100px;
    font-size: 16px;
    color: #aaa;

    @include device(mobile) {
      margin-top: -60px;
    }
  }

  .embed {
    width: 100%;
    max-width: $size-max-width;

    & figure {
      width: 100%;
      height: 0;
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
    }

    & iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  
  .shadow {
    border: 1px solid #F2F2F2;
    box-shadow: 0 30px 20px 0 rgba(0,0,0,0.05);
  }

  .border {
    border: 1px solid #C8C8C8;
  }

  .border-light {
    border: 1px solid #eee;
  }

  .round {
    border-radius: 6px;
  }

  .circle {
    border-radius: 50%;
  }

  .mw200 {
    max-width: 200px; 
  }

  .mw280 { 
    max-width: 280px; 

    @include device(mobile) {
      max-width: 40vw;
    }
  }
  .mw600 { max-width: 600px; }
  .mw630 { max-width: 630px; }
  .mw730 { max-width: 730px; }
  .mw800 { max-width: 800px; }
  .mw960 { max-width: 960px; }

  .cols {
    display: grid;
    width: 100%;
    max-width: $size-max-width;
  }

  .col-2 {
    grid-gap: 20px;
    grid-template-columns: repeat(2, 1fr);

    @include device(mobile) {
      grid-gap: 5px;
    }
  }

  .col-3 {
    grid-gap: 30px;
    grid-template-columns: repeat(3, 1fr);

    @include device(mobile) {
      grid-gap: 5px;
    }
  }

  .col-2-row-2 {
    grid-gap: 10px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    
    @include device(mobile) {
      grid-gap: 5px;
    }
  }

  .col-2-row-3 {
    grid-gap: 10px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    
    @include device(mobile) {
      grid-gap: 5px;
    }
  }

  .col-2-row-4 {
    grid-gap: 10px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, 1fr);

    @include device(mobile) {
      grid-gap: 5px;
    }
  }

  .col-3-row-2 {
    grid-gap: 30px;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);

    @include device(mobile) {
      grid-gap: 5px;
    }
  }
    
</style>


// WEBPACK FOOTER //
// src/components/ProjectBody.vue